"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageDecode = exports.messageEncode = void 0;

var messageEncode = function messageEncode(decodedMessage) {
  var arrayBuffer = new TextEncoder().encode(decodedMessage).buffer;
  return new Uint8Array(arrayBuffer);
};

exports.messageEncode = messageEncode;

var messageDecode = function messageDecode(encodedMessage) {
  return new TextDecoder().decode(encodedMessage);
};

exports.messageDecode = messageDecode;